<template lang="pug">
  .ev-navigation-drawer--submenu.py-4
    .ev-title.ml-3 {{ $route.meta.title }}
    v-list.pr-0.pl-2
      v-list-item(
        v-for="(navItem, idx) in availableNavItems"
        :key="idx"
        :to="navItem.to"
        exact
      )
        v-list-item-icon
          v-icon {{ navItem.icon }}
        v-list-item-content
          v-list-item-title {{ navItem.text }}
</template>

<script>
export default {
  computed: {
    availableNavItems() {
      return this.$route.meta.drawerChildren.filter(
        ({ visibleFor, accessFor, accessArgs }) => this.$user.hasRoles(visibleFor)
          && (!this.$user.isEventManager || !accessFor?.length || this.$user.hasPermissions(accessFor, ...(accessArgs || []))),
      );
    },
  },
};
</script>
